import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();
  return (
    <>
      <Hero
        pageName="SERVICES / CLOUD & DATA MODERNIZATION"
        pageIntro="Migrate and optimize legacy systems to cloud for enhanced performance and scalability."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "data-modernization-migration",
            title: "Legacy Data Modernization",
            desc: "Modernize legacy systems with cloud migration, achieving 8X faster timelines and 100% data integrity.",
            technologies: "AWS DMS, Azure Data Factory, Spark, Airflow, Deequ",
            features: [
              "Legacy system migration",
              "Scalable cloud pipelines",
              "Data integrity validation",
              "Real-time analytics",
            ],
            impact: "8X faster migrations, 50% cost reduction",
            caseStudy: {
              client: "Global Financial Institution",
              challenge:
                "Legacy systems slowed analytics, increasing costs and risks.",
              solution:
                "NucleusTeq migrated legacy databases to AWS with DMS and Spark, ensuring 100% data integrity.",
              outcome: "Achieved 8X faster migration and reduced costs by 48%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard showing cloud migration progress and data integrity metrics, with AWS icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Financial, technical, digital art, 800x400px",
              altText: "Financial dashboard with cloud migration metrics",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "pipeline-modernization",
            title: "Data Pipeline Modernization",
            desc: "Modernize data pipelines with Spark and Airflow for enhanced performance and scalability.",
            technologies: "Spark, Airflow",
            features: [
              "Modernized pipelines",
              "Real-time processing",
              "Scalable workflows",
              "Error handling",
            ],
            impact: "60% faster data processing, 25% improved performance",
            caseStudy: {
              client: "Retail Corporation",
              challenge:
                "Legacy pipelines slowed customer analytics processing.",
              solution:
                "NucleusTeq modernized pipelines with Spark and Airflow, enabling real-time customer analytics.",
              outcome:
                "Reduced processing time by 58% and improved performance by 23%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with modernized pipeline metrics and analytics, featuring Spark icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with modernized data pipelines",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "cloud-migration-consulting",
            title: "Cloud Migration Consulting",
            desc: "Strategic cloud migration plans ensure seamless transitions with minimal disruption.",
            technologies: "Migration frameworks, cloud strategy tools",
            features: [
              "Strategic roadmaps",
              "Risk assessment",
              "Performance optimization",
              "Business alignment",
            ],
            impact: "50% reduced migration risks, 30% faster transitions",
            caseStudy: {
              client: "Healthcare Organization",
              challenge:
                "Unplanned cloud migrations risked disruptions in patient data analytics.",
              solution:
                "NucleusTeq provided strategic consulting, designing a risk-free cloud migration roadmap.",
              outcome:
                "Reduced migration risks by 48% and sped up transitions by 27%.",
            },
            imagePrompt: {
              description:
                "A healthcare dashboard with cloud migration roadmaps and risk metrics, featuring cloud strategy icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Healthcare, strategic, digital art, 800x400px",
              altText: "Healthcare dashboard with cloud migration roadmap",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-integrity",
            title: "Data Integrity Validation",
            desc: "Automated validation ensures 100% data integrity during cloud migrations.",
            technologies: "Deequ",
            features: [
              "Automated validation",
              "Data consistency",
              "Error detection",
              "Scalable checks",
            ],
            impact: "100% data integrity, 20% reduced errors",
            caseStudy: {
              client: "Pharmaceutical Company",
              challenge:
                "Data errors during migration risked regulatory compliance.",
              solution:
                "NucleusTeq implemented Deequ for automated validation, ensuring error-free data migration.",
              outcome:
                "Achieved 100% data integrity and reduced errors by 18%.",
            },
            imagePrompt: {
              description:
                "A pharmaceutical dashboard with data integrity metrics and validation results, featuring Deequ icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Pharmaceutical, analytical, digital art, 800x400px",
              altText:
                "Pharmaceutical dashboard with data integrity validation",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "informatica-spark",
            title: "Informatica to Spark/Databricks/Cloud",
            desc: "Convert Informatica workflows to Spark on Databricks or any cloud for 5X performance and 80% reduced migration time.",
            technologies:
              "Databricks,EMR, DataProc, Spark, Spark Streaming, Delta Lake",
            features: [
              "Workflow conversion",
              "Real-time analytics",
              "Automated migrations",
              "Performance optimization",
            ],
            impact: "80% reduced migration time, 5X performance",
            caseStudy: {
              client: "Banking Institution",
              challenge:
                "Legacy Informatica workflows limited analytics performance.",
              solution:
                "NucleusTeq converted workflows to Spark/Databricks, enabling real-time financial analytics.",
              outcome:
                "Reduced migration time by 78% and improved performance by 4.8X.",
            },
            imagePrompt: {
              description:
                "A banking dashboard with Spark-based analytics and migration metrics, featuring Databricks icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Banking, technical, digital art, 800x400px",
              altText: "Banking dashboard with Spark/Databricks migration",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "real-time-analytics",
            title: "Real-Time Analytics Enablement",
            desc: "Enable real-time analytics with streaming pipelines for dynamic, low-latency insights.",
            technologies: "Spark Streaming, Delta Lake",
            features: [
              "Real-time processing",
              "Low-latency analytics",
              "Scalable pipelines",
              "Data consistency",
            ],
            impact: "60% faster insights, 25% reduced latency",
            caseStudy: {
              client: "Retail Company",
              challenge:
                "Delayed analytics impacted real-time sales optimization.",
              solution:
                "NucleusTeq implemented Spark Streaming pipelines for dynamic sales analytics.",
              outcome:
                "Reduced insight latency by 58% and improved sales optimization by 22%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with real-time sales analytics, featuring Spark Streaming icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with real-time analytics",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "migration-automation",
            title: "Migration Automation",
            desc: "Automate migrations with Databricks workflows to streamline processes and reduce effort.",
            technologies: "Databricks workflows",
            features: [
              "Automated migrations",
              "Scalable workflows",
              "Error reduction",
              "Process streamlining",
            ],
            impact: "50% reduced manual effort, 30% faster migrations",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Manual migrations increased costs and delays in analytics upgrades.",
              solution:
                "NucleusTeq automated migrations with Databricks workflows, streamlining analytics upgrades.",
              outcome:
                "Reduced manual effort by 48% and sped up migrations by 27%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with automated migration metrics, featuring Databricks icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Telecom, technical, digital art, 800x400px",
              altText: "Telecom dashboard with migration automation",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "performance-optimization",
            title: "Performance Optimization Consulting",
            desc: "Optimize data pipelines for 5X performance through strategic consulting and advanced tools.",
            technologies: "Performance frameworks, optimization tools",
            features: [
              "Performance audits",
              "Pipeline optimization",
              "Scalability planning",
              "Cost efficiency",
            ],
            impact: "5X performance, 40% cost savings",
            caseStudy: {
              client: "Global Logistics Firm",
              challenge:
                "Underperforming pipelines slowed logistics analytics.",
              solution:
                "NucleusTeq conducted performance audits, optimizing pipelines for high-speed analytics.",
              outcome: "Achieved 4.9X performance and reduced costs by 38%.",
            },
            imagePrompt: {
              description:
                "A logistics dashboard with pipeline performance metrics, featuring optimization tool icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Logistics, analytical, digital art, 800x400px",
              altText: "Logistics dashboard with performance optimization",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "hadoop-cloud",
            title: "Hadoop to Cloud Modernization",
            desc: "Migrate Hadoop clusters to cloud for 10X performance and 70% cost savings.",
            technologies: "AWS EMR, Dataproc, Spark, Hive, AWS Trusted Advisor",
            features: [
              "Cluster migration",
              "Cost optimization",
              "Performance tuning",
              "Cloud roadmaps",
            ],
            impact: "10X performance, 70% cost savings",
            caseStudy: {
              client: "Media Company",
              challenge:
                "Legacy Hadoop clusters limited content analytics scalability.",
              solution:
                "NucleusTeq migrated Hadoop to AWS EMR, optimizing performance with Spark.",
              outcome: "Achieved 9.5X performance and reduced costs by 68%.",
            },
            imagePrompt: {
              description:
                "A media dashboard with cloud-based analytics, featuring AWS EMR icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Media, technical, digital art, 800x400px",
              altText: "Media dashboard with Hadoop to cloud migration",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "cost-optimization",
            title: "Cost Optimization Services",
            desc: "Optimize cloud costs with AWS Trusted Advisor for maximum ROI and efficiency.",
            technologies: "AWS Trusted Advisor",
            features: [
              "Cost auditing",
              "Resource optimization",
              "Budget alignment",
              "ROI maximization",
            ],
            impact: "60% cost savings, 30% higher ROI",
            caseStudy: {
              client: "Healthcare Provider",
              challenge: "High cloud costs strained analytics budgets.",
              solution:
                "NucleusTeq used AWS Trusted Advisor to audit and optimize cloud resources.",
              outcome: "Reduced costs by 58% and increased ROI by 27%.",
            },
            imagePrompt: {
              description:
                "A healthcare dashboard with cloud cost optimization metrics, featuring AWS Trusted Advisor icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Healthcare, analytical, digital art, 800x400px",
              altText: "Healthcare dashboard with cloud cost optimization",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "performance-tuning",
            title: "Performance Tuning",
            desc: "Tune Hadoop clusters with Spark and Hive for optimized performance and scalability.",
            technologies: "Spark, Hive",
            features: [
              "Performance optimization",
              "Scalable clusters",
              "Resource efficiency",
              "Low-latency processing",
            ],
            impact: "70% improved performance, 25% reduced latency",
            caseStudy: {
              client: "Retail Corporation",
              challenge: "Suboptimal Hadoop clusters slowed sales analytics.",
              solution:
                "NucleusTeq tuned clusters with Spark and Hive, optimizing sales analytics performance.",
              outcome:
                "Improved performance by 68% and reduced latency by 23%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with tuned analytics performance, featuring Spark icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with performance tuning",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "migration-strategy",
            title: "Migration Strategy Consulting",
            desc: "Design Hadoop-to-cloud migration roadmaps for seamless, high-performance transitions.",
            technologies: "Migration frameworks, strategic planning",
            features: [
              "Strategic roadmaps",
              "Risk assessment",
              "Performance planning",
              "Business alignment",
            ],
            impact: "50% reduced migration risks, 40% faster transitions",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Unplanned Hadoop migrations risked analytics disruptions.",
              solution:
                "NucleusTeq designed a strategic roadmap for Hadoop-to-cloud migration, minimizing risks.",
              outcome:
                "Reduced migration risks by 48% and sped up transitions by 38%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with Hadoop migration roadmaps, featuring strategic planning icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Telecom, strategic, digital art, 800x400px",
              altText: "Telecom dashboard with migration strategy roadmap",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "ssis-sql-spark",
            title: "SSIS/SP/SQL to Spark",
            desc: "Convert SSIS and SQL workflows to Spark for 3X faster queries and 60% lower costs.",
            technologies: "Azure Data Factory, Spark SQL, Delta Lake",
            features: [
              "Workflow conversion",
              "SQL migration",
              "Pipeline optimization",
              "Cost efficiency",
            ],
            impact: "3X faster queries, 60% lower costs",
            caseStudy: {
              client: "Insurance Provider",
              challenge: "Legacy SSIS/SQL workflows slowed claims analytics.",
              solution:
                "NucleusTeq converted SSIS/SQL to Spark SQL, optimizing claims analytics pipelines.",
              outcome: "Achieved 2.9X faster queries and reduced costs by 58%.",
            },
            imagePrompt: {
              description:
                "An insurance dashboard with Spark-based claims analytics, featuring Spark SQL icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Insurance, analytical, digital art, 800x400px",
              altText: "Insurance dashboard with SSIS/SQL to Spark conversion",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "sql-spark",
            title: "SQL to Spark Conversion",
            desc: "Migrate SQL stored procedures to Spark SQL for faster, scalable analytics.",
            technologies: "Spark SQL",
            features: [
              "SQL migration",
              "Scalable queries",
              "Performance optimization",
              "Cloud integration",
            ],
            impact: "60% faster queries, 30% reduced costs",
            caseStudy: {
              client: "Retail Company",
              challenge: "Legacy SQL procedures slowed sales analytics.",
              solution:
                "NucleusTeq converted SQL procedures to Spark SQL, optimizing sales analytics.",
              outcome: "Reduced query time by 58% and costs by 28%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with Spark SQL analytics, featuring Spark SQL icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with SQL to Spark conversion",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "modernization-consulting",
            title: "Modernization Consulting",
            desc: "Design SQL-to-Spark strategies to modernize data ecosystems and boost analytics.",
            technologies: "Strategic frameworks, modernization tools",
            features: [
              "Modernization roadmaps",
              "Performance planning",
              "Business alignment",
              "Scalability strategies",
            ],
            impact: "40% faster analytics, 30% improved outcomes",
            caseStudy: {
              client: "Media Company",
              challenge:
                "Legacy SQL systems limited content analytics scalability.",
              solution:
                "NucleusTeq designed a SQL-to-Spark modernization strategy, boosting analytics performance.",
              outcome:
                "Reduced analytics time by 38% and improved outcomes by 27%.",
            },
            imagePrompt: {
              description:
                "A media dashboard with modernized analytics metrics, featuring strategic framework icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Media, strategic, digital art, 800x400px",
              altText: "Media dashboard with modernization consulting",
            },
            buttunData: {
              buttonText: "Modernize Your Data Today",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Get a Free Assessment",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
